<template>
  <div class="position-relative d-flex align-items-center justify-center">
    <v-tooltip
      right
      max-width="300px"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          color="primary"
          outlined
          fab
          small
          class="border border-nitro d-flex align-items-center justify-center"
          :class="{
            'bg-transparent border border-white' : $store.state.module.view_dark,
          }"
          v-on="on"
          @click="showModal = true"
        >
          <img
            class="mt-1"
            :src="`/images/bt_report_${$store.state.module.view_dark ? 'white': 'color'}.png`"
            width="25px"
          >
        </v-btn>
      </template>
      <span>Reportar problema no conteúdo</span>
    </v-tooltip>
    <v-dialog
      v-model="showModal"
      :overlay-opacity="0.7"
      :width="$vuetify.breakpoint.smAndUp ? '800px' : '100%'"
    >
      <v-card>
        <v-card-title class="border-bottom">
          <v-row>
            <v-col cols="12">
              <p class="mr-2 mb-0">
                Relatar um problema encontrado em
                <span class="text-italic">
                  {{ content ? content.title : 'Videocast' }}
                </span>
              </p>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="px-4">
          <div
            class="bg-custom-gray my-4"
            elevation="0"
          >
            <v-container fluid>
              <v-row>
                <v-col
                  :cols="4"
                  class="d-flex flex-column justify-content-between"
                >
                  <div>
                    <p class="text-black font-16 mb-2 font-weight-semibold">
                      Dispositivo
                    </p>
                    <v-select
                      v-model="form.device"
                      class="bg-white"
                      :items="devices"
                      placeholder="Selecione"
                      outlined
                      dense
                    />
                  </div>
                  <div>
                    <input
                      ref="imageInput"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      class="d-none"
                      @change="onChangeFile"
                    >
                    <p class="font-16 font-weight-semibold mb-2 text-black">
                      Imagem
                    </p>
                    <v-btn
                      color="primary"
                      @click="$refs.imageInput.click()"
                    >
                      Imagem
                    </v-btn>
                    <p
                      v-if="form.file"
                      class="text-lowercase text-body-2"
                    >
                      {{ form.file.name }}
                    </p>
                    <v-text-field
                      v-if="form.device == 'Outro'"
                      v-model="form.customDevice"
                      :counter="10"
                      class="bg-white"
                      label="Nome do dispositivo"
                      required
                    />
                  </div>
                </v-col>
                <v-col :cols="8">
                  <p class="font-16 text-black font-weight-semibold mb-2">
                    Mensagem
                  </p>
                  <v-textarea
                    v-model="form.message"
                    :value="form.message"
                    color="primary"
                    counter
                    class="bg-white border-radius-sm border rounded"
                    placeholder="Relate o problema"
                    rounded
                    :rules="rules"
                  />
                </v-col>
                <v-col />
                <v-col :cols="12">
                  <p class="font-weight-bold text-black">
                    Atenção
                  </p>
                  <p class="text-black mb-0">
                    O canal Reportar problema é específico para problemas relacionados a problemas de conteúdo. Problemas relacionados a tecnologia ou falha no acesso devem ser reportados diretamente à coordenação da escola.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end border-top">
          <v-btn
            color="primary"
            class="font-weight-bold text-capitalize"
            outlined
            @click="showModal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            class="font-weight-bold px-4 white--text text-capitalize"
            :disabled="disabled"
            @click="storeTicket"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'TicketCreate',
  data() {
    return {
      showModal: false,
      form: {
        message: '',
        device: '',
        file: null,
        customDevice: '',
      },
      devices: [
        'Desktop (computador)',
        'Notebook',
        'iPad',
        'Tablet Android',
        'iPhone',
        'Smartphone Android',
        'Outro'
      ]
    }
  },
  computed: {
    ...mapGetters(['authUser','content','module']),
    rules(){
      return [
        (value) => value.length > 10 || 'insira ao menos 10 caracteres',
      ]
    },
    device(){
      return this.form.device != 'Outro' ?  this.form.device : `${this.form.customDevice} (${this.form.device})`
    },
    disabled(){
      return this.form.message.length < 10 || !this.form.file || !(this.form.device != 'Outro' ? this.form.device.length : this.form.customDevice )
    }
  },
  methods: {
    onChangeFile(e){

      const files = e.target.files

      if(files && !['image/png','image/jpeg','image/jpg','image/gif'].includes(files[0].type)){
        console.log(files[0].type)
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: 'O arquivo selecionado deve ser uma imagem'
        });
        return ;
      }

      if(files) {
        this.form.file = files ? files[0] : null;
      }
    },
    ...mapActions(['isLoading']),
    async storeTicket() {

      this.isLoading();
      const message = `
      ${this.form.message}
      [*]
        Módulo: ${this.module.name},
        Posicão:${this.content ? this.content.order+1 : 'Videocast'},
        ${this.content && this.content.type == 'quiz' ? `Quantidade de Questões: ${this.content.content.length}`: ''},
      `
      const form = new FormData;

      form.append('message', message)
      form.append('device', this.device)
      form.append('file', this.form.file)
      form.append('ticketable_id', !this.content || this.content.type == 'quiz'  ? this.module.id : this.content.ticketable_id)
      form.append('ticketable_type', this.content ? this.content.type : 'videocast')

      axios.post('/api/v1/ticket', form , { headers: { "Content-Type": `multipart/form-data`,}})
      .then(()=> {
        this.message = '';
        this.file = '';
        this.showModal = false;
        this.$notify({
          type: 'success',
          title: 'Sucesso',
          text: 'Mensagem enviada com sucesso!'
        });
      })
      .catch((e) => {
        const {response : { data : { errors : { message : messages }}}} = e;
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: messages[0] ?? 'Ocorreu um erro ao enviar a mensagem'
        });
        })
      .finally(() => {
        this.isLoading(false);
      })

    }
  }
}
</script>
<style lang="css" scoped>
  .text-gray {
    color: #767676 !important;
  }
</style>